import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";

import Paper from "@mui/material/Paper";
import dayjs from "dayjs";
import { styled } from "@mui/material/styles";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import Stack from "@mui/material/Stack";
import LoopIcon from "@mui/icons-material/Loop";
import BackupIcon from "@mui/icons-material/Backup";
import Tooltip from "@mui/material/Tooltip";
import TextField from "@mui/material/TextField";
import { Loader } from "../../atoms/Loader";
import {
  getAllSetting,
  deleteSetting,
} from "../../../APICalling/ServiceAPICalling";
import {
  dateFormat,
  EXTENSION_IDENTIFIER,
} from "../../../config/serviceConstant";
import {
  createCronJobOrg,
  getCronJobsOrg,
  upsertSetting,
} from "../../../APICalling/Other";

const ProSpan = styled("span")({
  display: "inline-block",
  height: "1em",
  width: "1em",
  verticalAlign: "middle",
  marginLeft: "0.3em",
  marginBottom: "0.08em",
  backgroundSize: "contain",
  backgroundRepeat: "no-repeat",
  backgroundImage: "url(https://mui.com/static/x/pro.svg)",
});

function CronSetting(props) {
  const {
    children,
    tabIndex,
    index,
    orgid,
    apikey,
    datacenterurl,
    datacenter,
    zuid,
    zapikey,
    ...other
  } = props;
  const [loading, setLoading] = useState(false);
  const [reload, setReload] = useState(false);
  const [setting, setSetting] = useState({});
  const [cronjoborg, setCronjoborg] = useState({});
  const [settings, setSettings] = useState({});
  const [value, setValue] = useState(null);

  const getAllSettings = async ({ headers, params }) => {
    try {
      const settingData = await getAllSetting({ headers, params });

      return settingData?.data || [];
    } catch (error) {
      return [];
    }
  };

  const getExecuteCronjob = async () => {
    try {
      let delugeRestApi =
        datacenterurl +
        "/crm/v2/functions/easyattachmentarchiveforzohocrm__executecron/actions/execute?auth_type=apikey&zapikey=" +
        zapikey;

      let config = {
        orgid,
        apikey,
      };
      let cronJobsOrgResp = await getCronJobsOrg(config);
      let executeJob = cronJobsOrgResp?.data.find(
        (job) => job?.url == delugeRestApi
      );
      if (executeJob?.job_id) {
        return executeJob;
      }
      return {};
    } catch (error) {
      return {};
    }
  };

  const handleCreateSetting = async () => {
    let historicConfig = {
      data: {
        settingId: setting?.setting_id || "",
        settingSchema: { fetchingDate: value.format(dateFormat) },
        showInRelatedList: false,
        moduleApiName: "All",
        settingType: "historicDataUpload",
      },
      orgid,
      apikey,
      datacenter,
      datacenterurl,
    };

    const upsertSettingResp = await upsertSetting(historicConfig);

    const setting_id = upsertSettingResp?.data?.setting_id;
    const reqHeaders = {
      orgid,
      connname: EXTENSION_IDENTIFIER,
      apikey,
      datacenterurl,
    };
    const data = {
      url:
        datacenterurl +
        "/crm/v2/functions/easyattachmentarchiveforzohocrm__executecron/actions/execute?auth_type=apikey&zapikey=" +
        zapikey,
      name: `${orgid}__${EXTENSION_IDENTIFIER}`,
      params: {},
      headers: reqHeaders,
      body: {},
      type: "GET",
      execute_in: 1,
    };
    const cronjobOrgResp = await createCronJobOrg(data, reqHeaders);
    setReload((prev) => !prev);
  };

  // const handleCreateSetting = () => {
  //   try {

  //     // dayjs(value, 'YYYY-MM-DD')

  //   } catch (error) {
  //     return [];
  //   }
  // };

  const checkData = async (cb) => {
    let params = { settingType: "historicDataUpload" };
    // params = {};
    let headers = { orgid, apikey, connname: EXTENSION_IDENTIFIER };
    const settings = await getAllSettings({ headers, params });
    const executeJob = await getExecuteCronjob();

    const returnData = {
      bool: true,
      settings: settings,
      executeJob: executeJob,
    };
    cb(returnData);
  };

  const deleteSettingById = async (settingId) => {
    try {
      let headers = { orgid, apikey, connname: EXTENSION_IDENTIFIER };
      const settingResp = await deleteSetting({ settingId, headers });
    } catch (error) {}
  };

  useEffect(() => {
    if (orgid && apikey && tabIndex === index) {
      setLoading((prev) => true);
      checkData((returnData) => {
        let setting = returnData?.settings?.[0];

        setSettings((prev) => returnData?.settings || []);
        setCronjoborg((prev) => returnData?.executeJob || {});
        setSetting((prev) => setting || {});
        try {
          setValue(dayjs(JSON.parse(setting?.setting_schema)?.fetchingDate));
        } catch (error) {}
        setLoading((prev) => false);
      });
    }
  }, [tabIndex, reload]);

  if (tabIndex != index) {
    return <></>;
  }

  if (loading) {
    return <Loader />;
  }

  if (!orgid || !apikey || !datacenterurl) {
    return (
      <>
        Some of the data are missing
        {orgid}-{apikey}-{datacenterurl}
      </>
    );
  }

  // return
  // <div>
  //   <DatePicker onChange={onChange} value={value} />
  // </div>
  // return <DatePicker selected={startDate} onChange={(date) => setStartDate(date)} />;

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box
        sx={{
          // maxWidth: "80%",
          mx: "auto",
          py: 1,
          px: 1,
        }}
      >
        <Typography variant="h5" fontWeight={600} gutterBottom>
          Historic Attachment Backup
        </Typography>
        <Typography variant="body1" color="text.secondary" mb={3}>
          Pick a date to start backing up your past attachments. We’ll take care
          of the rest.
        </Typography>

        <Card
          sx={{ backgroundColor: "#f6f8fa", borderRadius: 2, py: 2, px: 2 }}
        >
          <CardContent>
            <Stack spacing={2}>
              <span style={{ mb: 3 }}>
                <Typography
                  variant="h6"
                  fontWeight={500}
                  sx={{
                    lineHeight: 1.8,
                  }}
                >
                  Pick a Start Date
                </Typography>
                <span style={{ color: "#00000099", fontSize: "16px" }}>
                  Choose when you want to begin backing up older attachments.
                </span>
              </span>
              <br />
              <Box>
                <DatePicker
                  label="Start Date"
                  value={value}
                  format="DD-MM-YYYY"
                  disableFuture
                  onChange={(newValue) => setValue(newValue)}
                  slotProps={{
                    textField: {
                      variant: "outlined",
                      size: "medium",
                      sx: {
                        width: "200px",
                        backgroundColor: "#fff",
                        mb: 1,
                      },
                    },
                  }}
                />

                <Typography variant="body2" color="text.secondary">
                  For example, if you choose August 15, 2010, we’ll back up all
                  attachments from that day onward.
                </Typography>
              </Box>

              <Alert
                severity="warning"
                variant="outlined"
                sx={{
                  backgroundColor: "#fef6f0",
                  border: "none",
                  borderLeft: "3px solid #f57c00",
                  color: "#000",
                  width: "fit-content",
                  fontSize: "14px",
                  borderRadius: "4px",
                }}
              >
                All backup and upload actions are governed by the{" "}
                <strong>Module Settings.</strong> Within the{" "}
                <strong>'Module Settings'</strong> tab, you can create specific
                configurations for each Zoho CRM module, defining the target
                drive, module root folder, and other related preferences. Only
                attachments belonging to modules with an active module setting
                will be processed and uploaded to the connected drive. If a
                module does <strong>not</strong> have any settings configured,
                its attachments will be <strong>ignored</strong> by the
                extension and will remain in Zoho CRM without being backed up.
                This ensures complete control over which modules and records are
                included in your backup strategy.
              </Alert>

              <Box>
                {cronjoborg?.job_id ? (
                  <Button
                    disabled={true}
                    variant="contained"
                    startIcon={<LoopIcon />}
                    onClick={handleCreateSetting}
                    sx={{ textTransform: "none", mt: 3 }}
                  >
                    Back Up In Progress
                  </Button>
                ) : (
                  <Button
                    variant="contained"
                    startIcon={<BackupIcon />}
                    onClick={handleCreateSetting}
                    sx={{ textTransform: "none", mt: 3 }}
                  >
                    Back Up
                  </Button>
                )}
              </Box>
            </Stack>
          </CardContent>
        </Card>
      </Box>
    </LocalizationProvider>
  );
}

export default CronSetting;
